import styled from 'styled-components'

export const CardIconsWrapper = styled.div`
  margin-right: 16px;
`
